import { createContext, useContext, useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "roofborder_theme";
const ThemeContext = createContext({ theme: "sombre", setTheme: () => {} });

/** Thème retenu, sinon la préférence du système, sinon sombre. */
function themeInitial() {
  if (typeof window === "undefined") return "sombre";
  const garde = localStorage.getItem(STORAGE_KEY);
  if (garde === "clair" || garde === "sombre") return garde;
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches
    ? "clair"
    : "sombre";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(themeInitial);

  // L'attribut sur <html> pilote toutes les variables CSS (voir index.css).
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme === "clair" ? "light" : "dark");
  }, [theme]);

  const setTheme = useCallback((t) => {
    const v = t === "clair" ? "clair" : "sombre";
    localStorage.setItem(STORAGE_KEY, v);
    setThemeState(v);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, basculer: () => setTheme(theme === "clair" ? "sombre" : "clair") }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
